import React from 'react';

import {ButtonVariantsEnum} from '../../../../../utils/_enums/button-variants.enum';
import {TypographyVariantsEnum} from '../../../../../utils/_enums/typeography-variants.enum';
import {Button} from '../../../../_shared/button/button';
import Dialog from '../../../../_shared/dialog/dialog';
import { Media } from '../../../../_shared/media/media';
import {Typography} from '../../../../_shared/typography/typography';
import styles from './variant-detail-stage-meta-box-audio-video.module.scss';

export interface Props {
    type: string;
    title: string;
    url: string;
    id?: number;
    onClose: () => void;
}

const audioFormats = ['mp3', 'ogg', 'wav', 'mpeg'];
const videoFormats = ['mp4'];

const resolveElementForData = (
    type: Props['type'],
    url: Props['url'],
    id: Props['id']
) => {
    const splittedUrl = type.split('/');

    const typeRes = splittedUrl[splittedUrl.length - 1];

    if (audioFormats.includes(typeRes ?? '')) {
        return (
            <audio controls>
                <source src={url} type={type}/>
                Your browser does not support the audio element.
            </audio>
        );
    } else if (videoFormats.includes(typeRes ?? '')) {
        return (
            <video width="320" height="240" controls>
                <source src={url} type={type}/>
                Your browser does not support the video tag.
            </video>
        );
    } else if (typeRes.includes('epub')) {
        return (
            <Button
                className={styles['button-wrapper']}
                variant={ButtonVariantsEnum.PRIMARY}
                onClick={() => window.open(`/epub-reader/${id}`)}
            >
                Öffnen
            </Button>
        );
    } else if (typeRes.includes('pdf')) {
        return (
            <div
            className={styles['button-wrapper']}>
                <Button

                    variant={ButtonVariantsEnum.PRIMARY}
                    onClick={() => window.open(url)}
                >
                    Öffnen
                </Button>
            </div>
        );
    } else {
        return (
            <div className={styles['image-button-wrapper']}>
                <Media
                    className={styles['image-sample']}
                    alt={''}
                    initialLoad={true}
                    src={url}
                />

                <div
                className={styles['button-wrapper']}>
                                    <Button
                    variant={ButtonVariantsEnum.PRIMARY}
                    onClick={() => window.open(url)}
                >
                    Öffnen
                </Button>
                </div>
            </div>
        );
    }
};

export const VariantDetailStageMetaBoxAudioVideo: React.FC<Props> = ({
                                                                         title,
                                                                         url,
                                                                         id,
                                                                         onClose,
                                                                         type
                                                                     }) => {
    return (
        <Dialog className='sample-dialog-container' onClose={onClose}>
            <div className={styles['variant-detail-stage-meta-box-audio-video']}>
                <Typography
                    element="h3"
                    variant={TypographyVariantsEnum.HEADING5}
                >
                    {title}
                </Typography>
                {resolveElementForData(type, url, id)}
            </div>
        </Dialog>
    );
};
